<div class="overview-selected-filters">
  <span
	  #translationSearchTerm
	  class="translation theme-primary-text-color"
	  i18n="message: Search:@@products.filters.selected.searchterm.text"
  >
    Search:
  </span>

	<span
		#translationGrower
		class="translation theme-primary-text-color"
		i18n="message: Grower:@@products.filters.selected.grower.text"
	>
    Filtered on grower
  </span>

	<span
		#translationItemNo
		class="translation theme-primary-text-color"
		i18n="message: Item No:@@products.filters.selected.itemNo.text"
	>
    Filtered on article:
  </span>

	<span
		#translationPotSizeFrom
		class="translation theme-primary-text-color"
		i18n="message: Pot size from:@@products.filters.selected.potSizeFrom.text"
	>
    Pot size from:
  </span>

	<span
		#translationPotSizeTo
		class="translation theme-primary-text-color"
		i18n="message: Pot size to:@@products.filters.selected.potSizeTo.text"
	>
    Pot size to:
  </span>

	<span
		#translationPriceFrom
		class="translation theme-primary-text-color"
		i18n="message: Price from:@@products.filters.selected.priceFrom.text"
	>
    Price from:
  </span>

	<span
		#translationPriceTo
		class="translation theme-primary-text-color"
		i18n="message: Price to:@@products.filters.selected.priceTo.text"
	>
    Price to:
  </span>

	<span
		#translationHeightFrom
		class="translation theme-primary-text-color"
		i18n="message: Height from:@@products.filters.selected.heightFrom.text"
	>
    Height from:
  </span>

	<span
		#translationHeightTo
		class="translation theme-primary-text-color"
		i18n="message: Height to:@@products.filters.selected.heightTo.text"
	>
    Height to:
  </span>

	<span
		#translationClearFeatureFilter
		class="translation theme-primary-text-color"
		i18n="
      message: Extended
      search:@@products.filters.selected.clearFeatureFilter.text"
	>
    Extended search
  </span>

	@if (selectedFilters && selectedFilters.length > 0) {
		<ul class="selected-filter-list">
			@for (filter of selectedFilters; track filter) {
				<li>
					<a (click)="filter.deselectCallback(filter)" class="selected-filter-list__filter">
						<span class="theme-primary-text-color">{{ filter.description }}</span>
						<span>
							<svg class="icon-cross-small" height="10" viewBox="0 0 10 10" width="10">
								<use xlink:href="images/icons/svg-sprite.svg#cross-small"></use>
                            </svg>
	                    </span>
					</a>
				</li>
			}
			<li class="selected-filter-list__reset theme-primary-text-color">
				<button (click)="resetFilters()" class="button--text theme-primary-text-color"
						i18n="message: Reset filters:@@products.filters.selected.resetFilters.text"
						type="button">
					Reset filters
				</button>
			</li>
		</ul>
	}
</div>
